import { fromJS } from 'immutable';

export const visibleColumns = fromJS([
  'year',
  'month',
  'day',
  'hour',
  'minute',
  'second',
  'eventValidity',
  'causeCode',
  'eqMagnitude',
  'volcanoEventId',
  'moreInfo',
  'numDeposits',
  'country',
  'locationName',
  'latitude',
  'longitude',
  'maxWaterHeight',
  'numRunups',
  'tsMtAbe',
  'tsMtIi',
  'tsIntensity',
  'deaths',
  'deathsAmountOrder',
  'missing',
  'missingAmountOrder',
  'injuries',
  'injuriesAmountOrder',
  'damageMillionsDollars',
  'damageAmountOrder',
  'housesDestroyed',
  'housesDestroyedAmountOrder',
  'housesDamaged',
  'housesDamagedAmountOrder',
  'deathsTotal',
  'deathsAmountOrderTotal',
  'missingTotal',
  'missingAmountOrderTotal',
  'injuriesTotal',
  'injuriesAmountOrderTotal',
  'damageMillionsDollarsTotal',
  'damageAmountOrderTotal',
  'housesDestroyedTotal',
  'housesDestroyedAmountOrderTotal',
  'housesDamagedTotal',
  'housesDamagedAmountOrderTotal',
]);

export const sort = fromJS([
  { id: 'year', asc: true },
  { id: 'month', asc: true },
  { id: 'day', asc: true },
  { id: 'hour', asc: true },
  { id: 'minute', asc: true },
  { id: 'second', asc: true },
]);

export const minColumns = fromJS([
  'year',
  'month',
  'day',
  'causeCode',
  'eqMagnitude',
  'volcanoEventId',
  'moreInfo',
  'locationName',
  'maxWaterHeight',
]);
